// extracted by mini-css-extract-plugin
export default {"placeholder":"SearchResult_placeholder__P0AAq","list":"SearchResult_list__KAVac"};